
import {Vue, Component} from "vue-property-decorator";
import {Getter} from "vuex-class";
import { formRules } from "@/utils/formRules";

@Component({})
export default class AddServiceCompany extends Vue {

    @Getter private isMobile: boolean;
    @Getter private envCompanyId: number|null;
    @Getter private envCompany: any;

    private showDialog: boolean = false;
    private loading: boolean = false;
    private siret: string = "";
    private showInvite: boolean = false;
    private displayEmailInput: boolean = false;
    private companyId: number = null;
    private companyData: any = null;
    private loadingCompanyData: boolean = false;
    private masterEmail: string = "";
    private rules: object = formRules;
    private step: string = "MAIN_STEP";

    get validForm(): boolean {
      return !!this.companyData?.contactName
        && formRules.isEmail(this.masterEmail)
        && formRules.isPhone(this.companyData.contactPhone);
    }

    get validSiret(): boolean {
      return formRules.siret(this.siret, false);
    }

    private reset(): void {
      this.showDialog = false;
      this.companyId = null;
      this.siret = "";
      this.showInvite = false;
      this.displayEmailInput = false;
      this.masterEmail = "";
      this.companyData = null;
      this.step = "MAIN_STEP";
    }

    private async getCompanyBySiret(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("companies/findOne", {
            siret: this.siret,
        }).then((res) => {
            if (res) {
              this.companyId = res.id;
              this.masterEmail = res.masterEmail;
            }
        }).catch((error) => {
            if (error.response?.status === 404) {
              // @TODO [MLB-790]: API call with SIRET to get new company data ?
              this.showInvite = true;
              this.$store.commit("alerts/displayWarning", {
                msg: this.$i18n.t("ServiceCompanies.notFound"),
              });
            } else {
              this.$store.commit("alerts/displayHttpError", { error });
            }
        }).finally(() => {
            this.loading = false;
        });
    }

    private async addServiceCompany(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("companies/addServiceCompany", {
            clientCompanyId: this.envCompanyId,
            serviceCompanyId: this.companyId,
        }).then(() => {
            this.reset();
            this.$emit("reset");
            this.$store.commit("alerts/displaySuccess", {
                msg: this.$i18n.t("ServiceCompanies.added"),
            });
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }

    private async fetchCompanyData(): Promise<void> {
        this.loadingCompanyData = false;
        await this.$store.dispatch("connectorPappers/getEntreprise", {
          siret: this.siret,
        }).then((res) => {
          if (res) {
            this.companyData = res;
          }
        }).catch((error) => {
          this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
          this.displayEmailInput = true;
          this.loadingCompanyData = false;
        });
    }

    private async inviteServiceCompany(): Promise<void> {
        this.loading = true;
        await this.$store.dispatch("companies/inviteServiceCompany", {
            clientCompanyId: this.envCompanyId,
            clientCompanyName: this.envCompany.name,
            siret: this.siret,
            masterEmail: this.masterEmail,
            serviceCompanyName: this.companyData.name,
            serviceCompanyActivitySector: this.companyData.activitySector || "",
            serviceCompanyAddress: this.companyData.address || "",
            serviceCompanyCity  : this.companyData.city || "",
            serviceCompanyZipCode: this.companyData.zipCode || "",
            serviceCompanyCountry: this.companyData.country || "",
            serviceCompanyContactName: this.companyData.contactName,
            serviceCompanyContactPhone: this.companyData.contactPhone,
        }).then(() => {
            // this.reset();
            this.step = "END_STEP";
            // this.$store.commit("alerts/displaySuccess", {
            //     msg: this.$i18n.t("ServiceCompanies.invitationSent"),
            // });
        }).catch((error) => {
            this.$store.commit("alerts/displayHttpError", { error });
        }).finally(() => {
            this.loading = false;
        });
    }
}
